// Magic numbers for file type detection
const TAR_MAGIC = new Uint8Array([0x75, 0x73, 0x74, 0x61, 0x72]) // "ustar" in ASCII

/**
 * Checks if the given array starts with the specified magic number
 */
function startsWithMagic(data: Uint8Array, magic: Uint8Array): boolean {
  if (data.length < magic.length) return false
  return magic.every((byte, i) => data[i] === byte)
}

/**
 * Detects if data is a tar file by checking magic numbers
 * Note: Checks for "ustar" at offset 257 (traditional tar format)
 */
export function isTar(data: Uint8Array): boolean {
  if (data.length < 262) return false // Too small to be a valid tar
  const magicBytes = data.slice(257, 262)
  return startsWithMagic(magicBytes, TAR_MAGIC)
}
